const ROUTE_COLORS = [
	{ name: 'niebieski', label: 'Niebieski', value: '#1974D2', aliases: ['niebieski'] },
	{ name: 'czerwony', label: 'Czerwony', value: '#D92121', aliases: ['czerwony'] },
	{ name: 'zielony', label: 'Zielony', value: '#2E7D32', aliases: ['zielony'] },
	{ name: 'fioletowy', label: 'Fioletowy', value: '#7B1FA2', aliases: ['fioletowy'] },
	{ name: 'pomaranczowy', label: 'Pomaranczowy', value: '#EF6C00', aliases: ['pomarańczowy', 'pomaranczowy'] },
	{ name: 'rozowy', label: 'Rozowy', value: '#C2185B', aliases: ['różowy', 'rozowy'] },
	{ name: 'turkusowy', label: 'Turkusowy', value: '#00897B', aliases: ['turkusowy'] },
	{ name: 'granatowy', label: 'Granatowy', value: '#283593', aliases: ['granatowy'] },
	{ name: 'brazowy', label: 'Brazowy', value: '#6D4C41', aliases: ['brazowy'] },
	{ name: 'szary', label: 'Szary', value: '#546E7A', aliases: ['szary', 'brak'] }
]

const LEGACY_ROUTE_COLORS = [
	{ name: 'jasny zielony', value: '#90EE90' },
	{ name: 'ciemny zielony', value: '#008443' },
	{ name: 'jasny niebieski', value: '#7CB9E8' },
	{ name: 'ciemny niebieski', value: '#0048BA' },
	{ name: 'jasny czerwony', value: '#FFCCCB' },
	{ name: 'ciemny czerwony', value: '#8B0000' },
	{ name: 'zolty', value: '#FADA5E', aliases: ['żółty'] },
	{ name: 'jasny zolty', value: '#FFFF9F', aliases: ['jasny żółty'] },
	{ name: 'ciemny zolty', value: '#EEDC82', aliases: ['ciemny żółty'] },
	{ name: 'jasny rozowy', value: '#FFB6C1', aliases: ['jasny różowy'] },
	{ name: 'ciemny rozowy', value: '#E75480', aliases: ['ciemny różowy'] },
	{ name: 'jasny pomaranczowy', value: '#FED8B1', aliases: ['jasny pomarańczowy'] },
	{ name: 'ciemny pomaranczowy', value: '#FF8C00', aliases: ['ciemny pomarańczowy'] }
]

const DEFAULT_ROUTE_COLOR = '#1974D2'
const FALLBACK_ROUTE_COLOR = '#CCCCCC'

const normalizeHexColor = value => {
	if (typeof value !== 'string') return null
	const trimmed = value.trim()
	if (!/^#[0-9a-fA-F]{6}$/.test(trimmed)) return null
	return trimmed.toUpperCase()
}

const sameName = (a, b) => String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase()

const findRouteColor = value => {
	const hex = normalizeHexColor(value)
	if (hex) {
		return ROUTE_COLORS.find(color => color.value.toUpperCase() === hex) ||
			LEGACY_ROUTE_COLORS.find(color => color.value.toUpperCase() === hex) ||
			{ name: value, label: value, value: hex, hex }
	}

	const match = [...ROUTE_COLORS, ...LEGACY_ROUTE_COLORS].find(color => {
		return sameName(color.name, value) || sameName(color.label, value) ||
			(color.aliases || []).some(alias => sameName(alias, value))
	})

	if (!match) return { name: 'brak', label: 'Brak', value: FALLBACK_ROUTE_COLOR, hex: FALLBACK_ROUTE_COLOR }
	return {
		...match,
		label: match.label || match.name,
		hex: match.value
	}
}

const getRouteColorValue = value => {
	const color = findRouteColor(value)
	return color.value || color.hex
}

export {
	ROUTE_COLORS,
	DEFAULT_ROUTE_COLOR,
	FALLBACK_ROUTE_COLOR,
	normalizeHexColor,
	findRouteColor,
	getRouteColorValue
}
